
/*
* Sticky Header
*/

var headerDiv = document.querySelector('header');

var stickyHeader = function (event) {
	let stickyoffsetTop = headerDiv.offsetTop;
	let windowOffsetTop = window.pageYOffset;

	if (windowOffsetTop > stickyoffsetTop) {
		headerDiv.classList.add('fixed');
	} else {
		headerDiv.classList.remove('fixed');
	}
};

window.addEventListener('scroll', stickyHeader, false);
window.addEventListener('load', stickyHeader, false);
window.addEventListener('resize', stickyHeader, false);
